module.exports = __webpack_public_path__ + "img/deviantart.6882cf9f.svg";